import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { openStartDropdown, closeStartDropdown, closeNavbar, openNavbar } from '../Actions/ToggleActions';

const ExploreButton = () => {
  const dispatch = useDispatch();
  const {
    language,
    text: { municipalityPage: pageText },
  } = useSelector(state => state.Language);
  const { startDropdownIsOpen } = useSelector(state => state.ToggleReducer);
  const municipality = useSelector(state => state.MunicipalityReducer);

  return (
    <button
      aria-label={startDropdownIsOpen ? pageText.explore : pageText.start}
      onClick={() => {
        if (startDropdownIsOpen) {
          dispatch(closeStartDropdown());
          dispatch(openNavbar());
        } else {
          dispatch(openStartDropdown());
          dispatch(closeNavbar());
          dispatch(push(`/${language}/${municipality.name}`));
        }
      }}
      className={`explore-button btn-content ${startDropdownIsOpen ? '' : 'show-all'}`}
    >
      <p>
        {startDropdownIsOpen ? pageText.explore : pageText.start}
      </p>
    </button>
  );
};

export default ExploreButton;




// WEBPACK FOOTER //
// ./src/Components/ExploreButton.js